import React from "react";
import "../Styles/Ferry.css";
import { useNavigate } from "react-router-dom";

const Ferry = () => {
  const navigate = useNavigate();
  return (
    <div className="ferry-page">
  <button className="back-button" onClick={() => navigate("/services")}>
    ← Back to Services
  </button>
  <div className="header-container">
    <h2>🚢Ferrypass Booking</h2>
  </div>
  <div className="section-container">
      <p>
RCS is the number ONE! recommended agent for ferrypass booking on Wakenaam!, Where we make it hastle free and convenient
to book your ferry pass tickets, for the Guyana Ferry service ANYWHERE in Guyana.

      </p>
      </div>
      <div className="section-container">
      <p>
    We provide ferry Booking for the following routes:
  <ul className="mmg-bullet-list">
    <li>WAKENAAM-PARIKA</li>
    <li>PARIKA-WAKENAAM</li>
    <li>PARIKA-LEGUAN</li>
    <li>LEGUAN-PARIKA</li>
    <li>PARIKA-SUPENAAM</li>
    <li>SUPENAAM-PARIKA</li>
    <li>GEORGETOWN-KUMAKA</li>
    <li>GEORGETOWN-PORT KAITUMA</li>
    <li>PARIKA-BARTICA</li>
    <li>BARTICA-PARIKA</li>
    <li>PARIKA-FORT ISLAND</li>
    <li>FORT ISLAND-PARIKA</li>
    <li>FORT ISLAND-BARTICA</li>
    <li>PORT KAITUMA-GEORGETOWN</li>
    <li>KUMAKA-GEORGETOWN</li>
  </ul>
      </p>
      </div>
      <div className="section-container">
      <p>
Wanna make your own booking? NO PROBLEM! head on over to the link below and handle our own booking like the boss you are, 
send us your booking number and lets make that payment to confirm it!
      </p>
      <a
    href="https://ferrypass.gy/search"
    target="_blank"
    rel="noopener noreferrer"
    className="booking-button"
  >
    Make Booking
  </a>

  <br /><br />
  <strong>ENSURE YOU HAVE YOUR "VEHICLE NUMBER", "PHONE NUMBER" AND VEHICLE TYPE AT HAND, BEFORE PROCEEDING, as incorrect information
    attracts a penalty upon boarding ferry!
  </strong>
      </div>
    </div>
  );
};

export default Ferry;
